import React, {Fragment,useEffect,useRef,useState } from 'react';
import DataGrid, {Paging,Button,LoadPanel,Sorting,Column,MasterDetail, Editing }  from 'devextreme-react/data-grid';
import {TableContextMenu} from './TableContextMenu';
import dayjs from "dayjs";
import duration from 'dayjs/plugin/duration';
import { convertToLocalTime, formatSLACountdown } from '../../commonFunctions/commonFunctions';
import { SlaLimits } from '../../Constantes/slaLimits';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { selectExpandedRows } from '../../redux/factoryCases/selectors';
import { CaseStates } from '../../Constantes/CaseStates';

dayjs.extend(duration);

export default function Table (props) {
    const { t } = useTranslation();
    const datasource = props.datasource;
    const [visible, setVisible] = useState(false);
    const [target, setTarget] = useState(".options");
    const [rowSelected, setRowSelected] = useState(null);
    const [enableEdit, setEnableEdit] = useState(false);
    const table = useRef(null);
    const factoryCommentsExpandedRows = useSelector(selectExpandedRows);

    function clickOpciones(e) {
        
        let grid = e.component;
        var rowKey = grid.getKeyByRowIndex(e.row.rowIndex);
        if (!e.row.isSelected){
            grid.selectRows([rowKey], props.type=== "Casos"? true : false);
        }
        if(props.type === "Casos"){props.handleSelectedRow(grid.getSelectedRowsData())};
        setTarget(document.getElementsByClassName("options")[e.row.rowIndex]);
        setVisible(true);
        setEnableEdit(props.type=== "Casos" ? grid.getSelectedRowKeys().length > 1 ? true : false : false);
        setRowSelected(e.row);
    }

    function handleOptionChange (e) {
        if(e.fullName === 'visible') {
            setVisible(false);
        }
    }

    function sortByFilters(e){
        if(props.filter){
            const filterBy= e.component.columnOption(props.filter?.columna)
            const columns = e.component.getVisibleColumns()
            const defaultFilter = columns.find(c => c.hasOwnProperty("sortIndex"))

            if (filterBy.name !== defaultFilter.name){

                if(filterBy.hasOwnProperty("sortIndex")===false){
                    
                    e.component.columnOption(filterBy.name, "sortIndex", 0)
                    e.component.columnOption(filterBy.name, "sortOrder", props.filter.orderAsc? "asc" : "desc" )
                    e.component.columnOption(defaultFilter.name, "sortIndex", undefined)
                    e.component.columnOption(defaultFilter.name, "sortOrder", undefined)
                }
            } else {
                e.component.columnOption(defaultFilter.name, "sortIndex", 0)
                e.component.columnOption(defaultFilter.name, "sortOrder", props.filter.orderAsc? "asc" : "desc" )
            }
        }
    }

    function formatCells(e){
        var rows= e.component.getVisibleRows();
        rows.forEach(row => {
            // const now = dayjs();
            // var scheduleDate = row.data?.scheduleDate;
            // const formattedDate = dayjs(scheduleDate)
            // const difference = now.diff(formattedDate);
            // if (difference > 0 && row.data?.state !== "Cerrado") {
            //     row.cells.map((cell)=>{cell.cellElement.classList.add("scheduleDateFormat");})
            // }

            if(row.data?.slaCloseDate){
                row.cells.map(cell => { 
                    if(cell.column.caption === "SLA"){
                        const slaClassName = getClassnameFromSLATime(row.data.creationDate, row.data.slaCloseDate, row.data.state);
                        const countdownText = formatSLACountdown(row.data.slaCloseDate, row.data.state);
                        cell.cellElement.classList.remove("sla-hours-high", "sla-hours-low", "normal");
                        cell.cellElement.classList.add(slaClassName);
                        cell.cellElement.innerText = countdownText;
                    }
                });
            }
            if(row.data?.brands){
                row.cells.map((cell)=>{if(cell.columnIndex==7){
                     cell.cellElement.classList.add("brandFormat");
                     cell.cellElement.innerText = cell.text.replace(/,/g,", ");
            }})
            }
            if(row.data?.state){
                row.cells.map(cell=>{ 
                    if(cell.column.dataField === "stateId"){
                        cell.cellElement.classList.add(getClassnameFromCaseStateId(row.data.stateId))}
                    }              
            )}
            // if(props.type === "Casos" && row.data.newFactoryActivity || row.data.factoryInteractionAllowed){
            //     row.cells.map((cell)=>{cell.cellElement.classList.add("factory-activity-warning")})
            // }
        });
        if(props.type === "CasosFabrica"){
            rows.forEach(row=>{
                if(factoryCommentsExpandedRows.some(expandedRow=> expandedRow === row.key.processId)){
                    e.component.expandRow(row.key)
                }
            })
        }
        if(props.type === "Historico"){
            rows.forEach(row=>{
                if(row.data.caseId === props.selectedHistoryCase)
                    e.component.selectRows([row.key], false)
            })
        }
    }

    function getClassnameFromSLATime(creationDate, slaTime, state) {
        const showDefaultStyle = !slaTime || !creationDate || state === "Cerrado";
        if (showDefaultStyle) {
            return "normal";
        }

        const currentTime = dayjs();
        const startTime = convertToLocalTime(creationDate);
        const slaTimeLocal = convertToLocalTime(slaTime);

        if (currentTime.isAfter(slaTimeLocal)) {
            return "sla-hours-high";
        }

        const totalDuration = dayjs(slaTimeLocal).diff(dayjs(startTime), 'minutes');
        const elapsedDuration = currentTime.diff(dayjs(startTime), 'minutes');

        if (totalDuration <= 0) {
            return "sla-hours-low";
        }

        const percentageElapsed = (elapsedDuration / totalDuration) * 100;

        if (percentageElapsed >= 80) {
            return "sla-hours-medium";
        }

        return "sla-hours-low";
    }

    function getClassnameFromCaseStateId(stateId){
        switch(stateId){
            case CaseStates.CLOSED:
            case CaseStates.NOT_MANAGED:
                return "state-cell-closed";
            case CaseStates.IN_PROGRESS:
                return "state-cell-in-progress"
            default:
                return "state-cell-other"
        }
    }

    useEffect(()=>{
        const tableRef = table.current || props.reference.current
        if(tableRef){
            if(props.loading === "loading"){
                tableRef.instance.beginCustomLoading(t("Loading"))
            } else {
            tableRef.instance.endCustomLoading()
            }
        } 
    },[props.loading]);

    useEffect(() => {
        const timerId = setInterval(() => {
            if (table.current && table.current.instance) {
                table.current.instance.repaint();
            }
        }, 60000);

        return () => clearInterval(timerId);
    }, []);

    return (
        <Fragment>
            <div>
                {(props.type === "Casos" || props.type === "Clientes") && 
                    <TableContextMenu key={target} type={props.type} setVisible={ (e) => setVisible(e)} enableChangeState={props.enableChangeState} handleChangeStateCases={props.handleChangeStateCases} handleSetNotManaged={props.handleSetNotManaged} caseStates={props.caseStates} handleOptionChange={handleOptionChange} target={table} visible={visible} rowSelected={rowSelected} enableEdit={enableEdit} handleRowClick={props.handleRowClick}/>
               }
                <DataGrid
                    ref={props.reference || table}
                    dataSource={datasource}
                    showBorders={false}
                    showColumnLines={false}
                    showRowLines={true}
                    noDataText={t("NoDataToDisplay")}
                    onOptionChanged={props.onOptionChanged}
                    onCellClick={props.handleCellClick}
                    onRowDblClick={props.handleRowClick}
                    onRowExpanding={props.onRowExpanding}
                    onRowCollapsing={props.onRowCollapsed}
                    onCellPrepared={props.onCellPrepared}
                    onRowPrepared={props.onRowPrepared}
                    showSortIndexes={false}
                    allowColumnResizing={true}
                    onInitialized={(e)=>sortByFilters(e)}
                    onContentReady={(e)=>formatCells(e)}
                    onDisposing={props.onDisposing}
                    onEditingStart={props.onEditingStart ?? null}
                    onSaving={props.onSaving ?? null}
                    onRowClick={function(e) {
                        if ( props.type === "Casos") {
                            let grid = e.component;
                            var rowKey = grid.getKeyByRowIndex(e.rowIndex);
                            if (!e.isSelected)
                                grid.selectRows([rowKey], props.type === "Casos" ? true : false);
                            else
                                grid.deselectRows([rowKey]);
                            
                            props.handleSelectedRow(grid.getSelectedRowsData());
                        }
                    }}
                >
                {
                    props.enableSorting !== undefined && !props.enableSorting  &&
                    <Sorting mode="none" />
                }
                <LoadPanel text={t("Loading")} showPane={true} />
                <Paging enabled={false}/>
                <MasterDetail
                    enabled={props.master}
                    component={props.masterDetail}
                />

                { props.editing && props.editing.enabled &&
                    <Editing mode={props.editing.mode ?? "cell"} selectTextOnEditStart={props.editing.selectTextOnEditStart} startEditAction={props.editing.startEditAction ?? "dblClick"} 
                        allowUpdating={props.editing.allowUpdating} onChangesChange={props.editing?.onChangesChange ? props.editing.onChangesChange : () => {} } 
                    />
                }
                {
                    (props.columnasTabla || []).map((value,index) => {
                        return value;
                    })
                }

                { props.type === "Casos" &&
                    <Column key={"botones"} width={50} type="buttons">
                        <Button cssClass="options" onClick={clickOpciones} hint={"Opciones"} icon="more" />
                    </Column>
                }
                </DataGrid>
            </div>
        </Fragment>
    );

}